import React, { useState, useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useStripePaiement from "../../hooks/useStripePaiement";
import PaymentMethodSelector from "../../components/payment/PaymentMethodSelector.jsx";
import OrangeMoneyModal from "../../components/payment/OrangeMoneyModal.jsx";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { AuthContext } from "../../contexts/AuthContext.js";
import "../../assets/css/article/ArticlePaiementPage.css";
import useArticles from "../../hooks/useArticle";
import { calculateAmount } from "../../utils/calculAmount";
import PaiementStatusModal from "../../components/payment/PaiementStatusModal.jsx";

const ArticlePaiementPage = ({ setAlert }) => {
  const { user } = useContext(AuthContext);
  const [formPaiement, setFormpaiement] = useState({
    paymentDetail: "",
  });
  const [paymentMethods, setPaymentMethods] = useState("mvola");
  const [loading, setLoading] = useState(false);
  const [prix, setPrix] = useState(null);
  const [prixFinal, setPrixFinal] = useState(prix);
  const [article, setArticle] = useState(null);
  const [categories, setCategories] = useState([]);
  const [isFree, setIsFree] = useState(process.env.REACT_APP_IS_FREE);
  const [remise, setRemise] = useState(0);
  const [couponValue, setCouponValue] = useState(null);
  const [orangeModal, setOrangeModal] = useState({
    open: false,
    url: null,
    orderId: null,
  });
  const [statusModal, setStatusModal] = useState({ open: false, status: null });
  const { findOneArticle } = useArticles();

  const { createPaiement } = useStripePaiement();
  const [searchParams] = useSearchParams();
  const stripe = useStripe();
  const elements = useElements();

  const id = searchParams.get("id") || "";
  const type = searchParams.get("type") || "";

  const navigate = useNavigate();

  const pageTitle =
    type == 3 ? "💳 Booster votre annonce" : "💳 Réabonnement de votre annonce";
  const pageDescription =
    type == 3
      ? "Le boost augmente la visibilité de votre annonce pour 1 jour."
      : "Le réabonnement prolonge la visibilité de votre annonce pour 30 jours.";
  const [validePhoneNumber, setValidePhoneNumber] = useState(false);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        await findOneArticle(id)
          .then((res) => {
            if (!res?.data?.data) return;
            setArticle(res.data.data);
            const data = res.data.data;
            const categoriePremium = data.categorie?.premium === 1;
            const nbrPhotos = data.photos.length;
            // const newAmount = calculateAmount(
            //   categoriePremium,
            //   nbrPhotos,
            //   type,
            // );
            const newAmount = type == 3 ? data.categorie?.prixBoost : data.categorie?.prixAbonnement;
            setPrix(isFree == 1 ? 0 : newAmount);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        console.error(err);
        setAlert?.({
          message: "Impossible de récupérer l'article.",
          type: "danger",
        });
      }
    };

    fetchArticle();
  }, [id, type]);

  const handleConfirm = async () => {
    if (!id) return;
    try {
      const methodePaiment =
        paymentMethods == "cb"
          ? "stripe"
          : paymentMethods == "mvola"
            ? "mvola"
            : paymentMethods == "orange"
              ? "orange"
              : "airtel";
      let paymentMethodStripe = null;
      if (isFree != 1 && prixFinal != 0) {
        if (paymentMethods == "cb") {
          const { paymentMethod, error } = await stripe.createPaymentMethod({
            type: "card",
            card: elements.getElement(CardElement),
          });
          paymentMethodStripe = paymentMethod;
          if (error) {
            console.error(error);
            setAlert({
              message:
                error.message || "Une erreur s'est produite lors du paiement.",
              type: "danger",
            });
            setLoading(false);
            return;
          }
        }
      }

      setLoading(true);
      const dataToSend = {
        methodPayment: paymentMethods == "cb" ? 4 : paymentMethods == "mvola" ? 1 : paymentMethods == "orange" ? 2 : 3,
        paymentMethodId: paymentMethodStripe?.id || null,
        idArticle: id,
        amount: isFree == 1 || prixFinal == 0 ? 0 : prixFinal,
        idUser: user?._id,
        type: type,
        devise: "MGA",
        phone: formPaiement?.paymentDetail || "",
        coupon: couponValue || "",
        amountInitial: prix || 0,
        amountRemise: remise || 0,
      };

      await createPaiement(
        dataToSend,
        isFree == 1 || prixFinal == 0 ? "gratuit" : methodePaiment,
      )
        .then(async (paiementRes) => {
          // Cas Orange Money : ouverture du modal au lieu de redirection directe
          if (methodePaiment === "orange") {
            const paymentUrl =
              paiementRes?.data?.payment_url || paiementRes?.payment_url;
            const orderId = paiementRes?.data?.orderId || paiementRes?.orderId;

            if (prixFinal == 0) {
              setLoading(false);
              setAlert?.({
                message:
                  isFree == 1 || prixFinal == 0
                    ? "Votre annonce a été publiée !"
                    : "En attente de validation du paiement. Veuillez patientez!",
                type: "success",
              });
              navigate("/article/succes");
              return;
            }

            if (paymentUrl) {
              setLoading(false);
              setOrangeModal({ open: true, url: paymentUrl, orderId });
              return;
            } else {
              setLoading(false);
              setAlert?.({
                message:
                  "Impossible de récupérer le lien de paiement Orange Money.",
                type: "danger",
              });
              return;
            }
          }

          // Cas gratuit / mvola / stripe / airtel : comportement existant
          setLoading(false);
          setAlert?.({
            message:
              isFree == 1 || prixFinal == 0
                ? "Votre annonce a été publiée !"
                : "En attente de validation du paiement. Veuillez patientez!",
            type: "success",
          });
          navigate("/article/succes");
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
          setAlert?.({
            message: `Erreur lors du ${type == 3 ? "boost" : "réabonnement"} de l'annonce.`,
            type: "danger",
          });
        });
    } catch (error) {
      console.error(error);
      setLoading(false);
      setAlert?.({
        message: `Erreur lors du ${type == 3 ? "boost" : "réabonnement"} de l'annonce.`,
        type: "danger",
      });
    }
  };

  const onCouponChange = (newPrixFinal) => {
    setPrixFinal(newPrixFinal);
  };

  return (
    <div className="content_article_paiement container mt-5 mb-5">
      <i
        className="bi bi-x-circle login_icon_x"
        role="button"
        onClick={() => {
          const path =
            type == 2
              ? `/utilisateur/mesAnnonces`
              : `/article/visualisation/${id}`;
          navigate(path);
        }}
      ></i>
      <div className="paiement_header">
        <h2>{pageTitle}</h2>
      </div>

      <div className="paiement_body">
        <p>{pageDescription}</p>
        <p className="text-muted">
          Choisissez votre mode de paiement et confirmez l'action.
        </p>

        {article && prix !== null ? (
          <PaymentMethodSelector
            paymentMethods={paymentMethods}
            setPaymentMethods={setPaymentMethods}
            formPaiement={formPaiement}
            setFormpaiement={setFormpaiement}
            totalAmount={isFree == 1 ? 0 : prix}
            prixFinal={prixFinal}
            setPrixFinal={setPrixFinal}
            isFree={isFree}
            validePhoneNumber={validePhoneNumber}
            setValidePhoneNumber={setValidePhoneNumber}
            onCouponChange={onCouponChange}
            couponValue={couponValue}
            setCouponValue={setCouponValue}
            remise={remise}
            setRemise={setRemise}
            type={type}
          />
        ) : (
          <p className="text-muted">Chargement du montant...</p>
        )}

        <button
          type="button"
          className={`btn_boost_confirm mt-3 ${
            loading ||
            prix === null ||
            !paymentMethods ||
            (paymentMethods !== "cb" && !validePhoneNumber) ||
            paymentMethods == "cb"
              ? "disabled"
              : ""
          }`}
          onClick={handleConfirm}
        >
          {loading
            ? "Traitement..."
            : type == 3
              ? "Confirmer le boost"
              : "Confirmer le réabonnement"}
        </button>
      </div>

      {orangeModal.open && (
        <OrangeMoneyModal
          paymentUrl={orangeModal.url}
          orderId={orangeModal.orderId}
          onSuccess={() => {
            setOrangeModal({ open: false, url: null, orderId: null });
            setStatusModal({ open: true, status: "success" });
          }}
          onFailure={() => {
            setOrangeModal({ open: false, url: null, orderId: null });
            setStatusModal({ open: true, status: "failed" });
          }}
          onClose={() =>
            setOrangeModal({ open: false, url: null, orderId: null })
          }
        />
      )}

      {statusModal.open && (
        <PaiementStatusModal
          status={statusModal.status}
          onClose={() => setStatusModal({ open: false, status: null })}
        />
      )}
    </div>
  );
};

export default ArticlePaiementPage;
